import * as React from "react";
import { PaginationButton } from "./PaginationButton";
import styled from "styled-components";

export const PaginationLayout = ({
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  totalPages,
  onPageChange,
  activePages,
}) => {
  return (
    <StyledLayout>
      <PaginationButton
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || isTableDataLoading}
      >
        <img
          src={
            currentPage === 1
              ? require("../../assets/images/left-arrow-icon-disabled.png")
              : require("../../assets/images/left-arrow-icon.png")
          }
          alt="left-icon"
        />
      </PaginationButton>
      {activePages.map((pageNo, idx) => (
        <PaginationButton
          disabled={isTableDataLoading}
          key={idx}
          label={pageNo}
          isActive={currentPage === pageNo}
          onClick={() => onPageChange(pageNo)}
        />
      ))}
      <PaginationButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages || isTableDataLoading}
      >
        <img
          src={
            currentPage === totalPages
              ? require("../../assets/images/right-arrow-icon-disabled.png")
              : require("../../assets/images/right-arrow-icon.png")
          }
          alt="right-icon"
        />
      </PaginationButton>
    </StyledLayout>
  );
};

const StyledLayout = styled.div`
  display: flex;
`;
